import { IsString, Length, IsEmail, IsEnum, IsUUID } from "class-validator";
import { ConfirmPassword } from "./validation/customValidators";
// import { Exclude } from "class-transformer";

// import { UserAddress } from "./user_address.entity";
// import { UserBankAccount } from "./user_bank_account.entity";
// import { UserPersonalInfo } from "./user_personal_info.entity";
// import { UserProfessionalInfo } from "./user_professional_info.entity";

// export enum UserRole {
// 	PROFESSIONAL = "PROFESSIONAL",
// 	OPERATOR = "OPERATOR",
// 	OPERATOR2 = "OPERATOR2",
// 	FINANCE = "FINANCE",
// 	FINANCE2 = "FINANCE2",
// 	COORDINATOR = "COORDINATOR",
// 	COORDINATOR2 = "COORDINATOR2",
// 	MASTER = "MASTER",
// 	MASTER2 = "MASTER2",
// }

// export enum UserStatus {
// 	PARTIAL_REGISTRATION = "PARTIAL_REGISTRATION",
// 	PENDING_APPROVAL = "PENDING_APPROVAL",
// 	APPROVED = "APPROVED",
// }

export class User {
	// @IsEnum(UserRole)
	// role: UserRole;

	// @Exclude()
	// @IsEnum(UserStatus)
	// status: UserStatus;

	@IsEmail({}, { groups: ["signup"] })
	email: string;

	@Length(8, 255, { groups: ["signup"] })
	password: string;

	@ConfirmPassword({ groups: ["signup"] })
	confirmPassword: string;

	// @IsString()
	// @Length(3, 150)
	// name?: string;

	// @OneToOne(type => UserAddress, userAddress => userAddress.user)
	// address: UserAddress;

	// @OneToOne(type => UserBankAccount, userBankAccount => userBankAccount.user)
	// bankAccount: UserBankAccount;

	// @OneToOne(type => UserPersonalInfo, userPersonalInfo => userPersonalInfo.user)
	// personalInfo: UserPersonalInfo;

	// @OneToOne(type => UserProfessionalInfo, userProfessionalInfo => userProfessionalInfo.user)
	// professionalInfo: UserProfessionalInfo;

	// @Exclude()
	// @IsUUID()
	// profilePictureUrl: string;  // used only during user update

	// @Length(0, 255)
	// @Column({ type: "varchar", length: 255, nullable: true })
	// profilePictureUrl: string;
}
